import React from 'react';
import {
  CarouselProduct,
  NavigateCarouselPayload,
  ProductCarousel,
  ProductCarouselProps,
} from '@noths/polaris-client-ribbons-design-system';

import { useRichRelevanceData } from '../../../hooks/useRichRelevanceData/useRichRelevanceData';
import { RichRelevanceProduct } from '../../../types/RecentlyViewed';
import { sendProductClickEvent, sendProductShelfImpressionEvent } from './tracking';

interface RecentlyViewedNavigateCarouselPayload extends NavigateCarouselPayload {
  numberOfItems: number;
}

export interface RecentlyViewedProps
  extends Pick<ProductCarouselProps, 'currency' | 'placementType' | 'placementTitle'> {
  items?: RichRelevanceProduct[];
  onNavigateCarousel?: (payload: RecentlyViewedNavigateCarouselPayload) => void;
  placementTitle?: string;
  strategy?: string;
}

export const RecentlyViewed = ({
  currency,
  items = [],
  onNavigateCarousel,
  placementTitle = '',
  placementType,
  strategy = '',
}: RecentlyViewedProps) => {
  const products = useRichRelevanceData(items);

  return (
    <div data-testid="RecentlyViewedCarousel">
      <ProductCarousel
        products={products as CarouselProduct[]}
        placementTitle={placementTitle}
        placementType={placementType}
        currency={currency}
        onComponentVisible={() =>
          sendProductShelfImpressionEvent(placementType, products, strategy)
        }
        onNavigateCarousel={(payload) => {
          onNavigateCarousel?.({ ...payload, numberOfItems: products.length });
        }}
        onProductClick={(evt, { index }) => {
          sendProductClickEvent(evt, products[index], index + 1, placementType, strategy);
        }}
      />
    </div>
  );
};
